import { DeskBookingHistory } from "../../../components";
function AdminBookingHistory() {
  return <DeskBookingHistory />;
}

export default AdminBookingHistory;
